import * as React from "react"

const IamIconMenu: React.FC = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlSpace="preserve"
        id="Layer_1"
        width="32"
        height="32"
        viewBox="0 0 32 32"
        enableBackground="new 0 0 70 70"
    >
        <linearGradient
        id="SVGID_1_"
        x1="15.7922"
        y1="0"
        x2="15.7922"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0062FF" />
        <stop offset="1" stop-color="#004BC2" />
      </linearGradient>
        <path
            d="M6.6 0h18.7C29 0 32 3 32 6.6v18.7c0 3.7-3 6.6-6.6 6.6H6.6C3 32 0 29 0 25.4V6.6C0 3 3 0 6.6 0z"
            style={{
                fill: "url(#SVGID_1_)",
                fillOpacity: 0.1,
            }}
        />
        <path
            d="M16 7.6c-.2.2-.4.3-.5.5-.8.7-1.7 1.3-2.7 1.8-.6.3-1.2.5-1.8.6-.7.2-1.4.2-2.1.2h-.2c-.1 0-.1 0-.1.1-.1.7-.1 1.4 0 2.1 0 .7 0 1.4.1 2.1 0 .3.1.6.2.9.1.6.2 1.1.4 1.6.1.5.3 1 .5 1.5.6 1.4 1.4 2.6 2.5 3.7.7.6 1.4 1.1 2.3 1.5.4.2.9.4 1.4.5h.5c.3-.1.7-.3 1-.4.2-.1.4-.2.5-.3 0 0 .1 0 .2-.1v1.4s0 .1-.1.1l-1.8.6H16c-.6-.1-1.2-.3-1.7-.6-.7-.3-1.4-.7-2.1-1.2-.6-.5-1.2-1-1.7-1.6-.8-1-1.5-2.1-1.9-3.2-.2-.5-.4-1-.5-1.6-.1-.4-.2-.9-.3-1.3-.1-.5-.2-.9-.2-1.4-.1-.4-.1-.8-.1-1.2-.1-.8-.1-1.6 0-2.4 0-.7.1-1.3.2-2 0-.2.2-.4.4-.3.1.2.5.3.9.3s.8 0 1.2-.1c.2 0 .3-.1.5-.1.3 0 .5-.1.8-.2.4-.2.7-.3 1.1-.5 1.1-.6 2.1-1.4 3-2.3l.2-.2c.2-.2.3-.2.5 0 1 1.1 2.1 2 3.5 2.7.7.3 1.4.6 2.2.7.7.1 1.4.1 2.2-.1.1 0 .3-.1.4.1 0 .1.1.1.1.2 0 .3.1.6.1 1 .1 1 .1 2 .1 3.1 0 .5-.1.9-.1 1.4 0 .5-.1 1-.2 1.6-.1.6-.2 1.2-.4 1.7v.1c0 .1 0 .1-.1.1H22.8c0-.1.1-.1.1-.2.2-.6.3-1.1.5-1.7.2-.8.3-1.6.4-2.4.1-.9.1-1.9.1-2.8V11c0-.1 0-.1-.1-.1h-.4c-.5 0-.9 0-1.4-.1-.3-.1-.7-.1-1-.2-1.3-.4-2.4-1-3.5-1.9-.8-.4-1.1-.7-1.5-1.1z"
            fill="#052351"
        />
        <path
            d="M12.8 18.4v-1.6c0-.2.1-.4.3-.5.3-.3.7-.4 1-.6.5-.2 1-.3 1.6-.4.4 0 .8 0 1.2.1.5.1 1.1.3 1.5.6.2.1.4.3.5.4.1.1.1.2.1.4v1.5c0 .1 0 .1-.1.1h-6.1zM19.5 23.1v-1.3c0-.1 0-.1.1-.1h.3c.1 0 .1 0 .1-.1v-.7c0-.5.2-.9.6-1.2.8-.7 1.9-.3 2.3.5.1.2.2.5.2.7v.7c0 .1 0 .1.1.2h.3c.1 0 .1 0 .1.1v2.6c0 .1 0 .2-.1.2-.4 0-.8 0-1.3.1h-1.1c-.5 0-1-.1-1.6-.1-.1 0-.1-.1-.1-.1.1-.6.1-1.1.1-1.5zm1-1.4h.6c.3 0 .6-.1.8 0 .2 0 .5 0 .7.1.1 0 .1 0 .1-.1V21c0-.1 0-.3-.1-.4-.2-.5-.5-.7-1-.8-.5 0-.8.2-1 .6-.1.1-.1.2-.1.4v.9zm.9 2c0 .2 0 .2.2.2.1 0 .1 0 .1-.1v-.2s0-.1.1-.1c.1-.1.2-.1.2-.2.1-.2 0-.5-.2-.6-.2-.1-.5 0-.6.2-.1.1-.1.4.1.6.1.1.1.2.1.2zM17.4 13.4c0 .9-.7 1.6-1.5 1.6s-1.5-.7-1.6-1.5c0-.9.7-1.6 1.6-1.6.7-.1 1.5.5 1.5 1.5z"
            fill="#052351"
        />
    </svg>
)
export default IamIconMenu
